import { render, staticRenderFns } from "./AppSidebarMenuItem.vue?vue&type=template&id=436d5c6f&"
import script from "./AppSidebarMenuItem.vue?vue&type=script&lang=ts&"
export * from "./AppSidebarMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppSidebarMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports